// extracted by mini-css-extract-plugin
export var articleVid = "videoEmbed-module--articleVid--5a7d1";
export var centerPlay = "videoEmbed-module--centerPlay--aa59d";
export var coverImage = "videoEmbed-module--coverImage--00be2";
export var coverText = "videoEmbed-module--coverText--9f38a";
export var coverTextPlaying = "videoEmbed-module--coverTextPlaying--ef78d videoEmbed-module--coverText--9f38a";
export var embed = "videoEmbed-module--embed--e6e0d";
export var featured = "videoEmbed-module--featured--f6ac7";
export var fullScreen = "videoEmbed-module--fullScreen--09c6b";
export var inline = "videoEmbed-module--inline--f7458";
export var inlineVideo = "videoEmbed-module--inlineVideo--16b08";
export var play = "videoEmbed-module--play--24411";
export var shortDesc = "videoEmbed-module--shortDesc--98540";
export var shortDescInner = "videoEmbed-module--shortDescInner--9bcd2";
export var slideUp = "videoEmbed-module--slideUp--c9684";
export var slideUpLarge = "videoEmbed-module--slideUpLarge--12847";
export var small = "videoEmbed-module--small--69f97";
export var videoContainer = "videoEmbed-module--videoContainer--2f3e3";
export var videoCover = "videoEmbed-module--videoCover--bea29";
export var videoEmbed = "videoEmbed-module--videoEmbed--41895";
export var videoEmbedTimeline = "videoEmbed-module--videoEmbedTimeline--4123a videoEmbed-module--videoEmbed--41895";
export var videoWrap = "videoEmbed-module--videoWrap--ac1c6";